import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { RawDataFilterSettingsModel } from "../../../models/dataSynchronization";
import { Dropdown } from 'primereact/dropdown';
import { AuthorisationStatus } from '../../../common/enums';
import { RawDataStatus } from '../../../common/enums';
import { DataSourceType } from '../../../common/enums';
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { DropdownModel } from "../../../models/dropdownModel";
import { getEnumLabel } from '../../../common/functions/helperFunctions';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface IState {
  loadDataSettings: RawDataFilterSettingsModel,
  authorisationStatusDropdown: Array<DropdownModel>,
  rawDataStatusDropdown: Array<DropdownModel>,
  dataSourceTypeDropdown: Array<DropdownModel>,
  selectedGroup: null,
  filterText: string
}

export class LoadDataFilter extends React.Component<IProps, IState>  {
  constructor(props) {
    super(props);
    this.state = {
      loadDataSettings: new RawDataFilterSettingsModel(),
      authorisationStatusDropdown: new Array<DropdownModel>(0),
      rawDataStatusDropdown: new Array<DropdownModel>(0),
      dataSourceTypeDropdown: new Array<DropdownModel>(0),
      selectedGroup: null,
      filterText: ''
    };
  }

  componentDidMount() {
    this.initializeDropdownFilters();
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const currentSettings: RawDataFilterSettingsModel = { ...this.state.loadDataSettings };
    currentSettings[name] = value;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      loadDataSettings: { ...currentSettings },
      filterText: fiterText
    });
  }

  handleDropdownChange = (key, value) => {
    const currentSettings: RawDataFilterSettingsModel = { ...this.state.loadDataSettings };
    currentSettings[key] = value;

    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      loadDataSettings: { ...currentSettings },
      filterText: fiterText
    });
  };

  generateFilterText = (settings) => {
    let result = '';

    if (settings.name) {
      result += "Brand Name <strong>'" + settings.name + "'</strong>, "
    }
    if (settings.number) {
      result += "Number <strong>'" + settings.number + "'</strong>, "
    }
    if (settings.authorisationStatusId && settings.authorisationStatusId > 0) {
      result += "Authorisation status <strong>'" + getEnumLabel(settings.authorisationStatusId, AuthorisationStatus, true) + "'</strong>, "
    }
    if (settings.rawDataStatusId && settings.rawDataStatusId > 0) {
      result += "Raw data status <strong>'" + getEnumLabel(settings.rawDataStatusId, RawDataStatus, true) + "'</strong>, "
    }
    if (settings.dataSourceTypeId && settings.dataSourceTypeId > 0) {
      result += "Data source type <strong>'" + getEnumLabel(settings.dataSourceTypeId, DataSourceType, true) + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  initializeDropdownFilters() {
    let authStatusDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(AuthorisationStatus, true));
    let rawDataStatusDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(RawDataStatus, true));
    let dataSourceTypeDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(DataSourceType, true));

    this.setState({
      authorisationStatusDropdown: authStatusDropdown,
      rawDataStatusDropdown: rawDataStatusDropdown,
      dataSourceTypeDropdown: dataSourceTypeDropdown
    });
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      loadDataSettings: new RawDataFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new RawDataFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.loadDataSettings)
    }
  }

  render() {
    const { authorisationStatusDropdown, rawDataStatusDropdown, dataSourceTypeDropdown } = this.state;

    return (
      <>
        <Toolbar style={{ marginBottom: '10px' }}>
          <div>
            <InputText
              onKeyPress={(e) => this.handleKeyPress(e)}
              style={{ marginRight: "10px", marginBottom: "5px" }}
              name="name"
              placeholder="Medicine Name"
              onChange={this.handleChange}
              value={this.state.loadDataSettings && this.state.loadDataSettings.name ? this.state.loadDataSettings.name : ''}
            />
            <InputText
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="number"
              style={{ marginRight: "10px", marginBottom: "5px" }}
              placeholder="Product Number"
              onChange={this.handleChange}
              value={this.state.loadDataSettings && this.state.loadDataSettings.number ? this.state.loadDataSettings.number : ''}
            />
            <Dropdown
              style={{ marginRight: "10px", marginBottom: "5px" }}
              value={this.state.loadDataSettings && this.state.loadDataSettings.authorisationStatusId ? this.state.loadDataSettings.authorisationStatusId : -1}
              options={authorisationStatusDropdown}
              onChange={(e) => this.handleDropdownChange('authorisationStatusId', e.value)}
            />
            <Dropdown
              style={{ marginRight: "10px", marginBottom: "5px" }}
              value={this.state.loadDataSettings && this.state.loadDataSettings.rawDataStatusId ? this.state.loadDataSettings.rawDataStatusId : -1}
              options={rawDataStatusDropdown}
              onChange={(e) => this.handleDropdownChange('rawDataStatusId', e.value)}
            />
            <Dropdown
              style={{ marginRight: "10px", marginBottom: "5px" }}
              value={this.state.loadDataSettings && this.state.loadDataSettings.dataSourceTypeId ? this.state.loadDataSettings.dataSourceTypeId : -1}
              options={dataSourceTypeDropdown}
              onChange={(e) => this.handleDropdownChange('dataSourceTypeId', e.value)}
            />
          </div>
          <div>
            <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
              Result: <strong>{this.props.totalRecordsCount}</strong>
              {this.state.filterText ? ', ' : ''}
              <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
            </div>
            <div style={{ float: "right" }}>
              <div>
                <Button
                  className="p-button-raised"
                  icon="pi pi-filter"
                  style={{ marginRight: "10px" }}
                  label="Filter"
                  onClick={() => this.handleSearchButtonClick(this.state.loadDataSettings)}
                />
                <Button
                  className="p-button-secondary p-button-raised"
                  label="Clear"
                  icon="pi pi-times"
                  onClick={() => this.handleClearButtonClick()}
                />
              </div>
            </div>
          </div>
        </Toolbar>
      </>
    )
  }
}

export default LoadDataFilter;
